import React from 'react';
import { MessageSquare, Send } from 'lucide-react';
import { Card } from '../ui/Card';
import { Button } from '../ui/Button';
import { Input } from '../ui/Input';
import { ZodiacTheme } from './zodiacThemes';
interface ChatTabProps {
  theme: ZodiacTheme;
}
export function ChatTab({
  theme
}: ChatTabProps) {
  return <div className="space-y-6 h-[calc(100vh-12rem)] min-h-[600px] flex flex-col" data-id="element-15602">
      <h2 className="text-2xl font-bold text-slate-900 mb-2" data-id="element-15603">Сообщения</h2>
      <Card padding="none" className="flex-grow flex overflow-hidden border border-slate-200" data-id="element-15604">
        <div className="w-full md:w-1/3 border-r border-slate-200 flex flex-col bg-white" data-id="element-15605">
          <div className="p-4 border-b border-slate-100" data-id="element-15606">
            <Input placeholder="Поиск сообщений..." icon={<MessageSquare className="w-4 h-4" data-id="element-15608" />} data-id="element-15607" />
          </div>
          <div className="overflow-y-auto flex-grow" data-id="element-15609">
            <div className={`p-4 border-b border-slate-100 ${theme.bg} cursor-pointer`} data-id="element-15610">
              <div className="flex items-start gap-3" data-id="element-15611">
                <div className="w-10 h-10 rounded-full bg-indigo-100 flex items-center justify-center text-indigo-700 font-bold flex-shrink-0" data-id="element-15612">
                  ЕС
                </div>
                <div className="flex-grow min-w-0" data-id="element-15613">
                  <div className="flex justify-between items-baseline mb-1" data-id="element-15614">
                    <h4 className="font-bold text-slate-900 truncate" data-id="element-15615">
                      Елена Смирнова
                    </h4>
                    <span className="text-xs text-slate-500" data-id="element-15616">14:20</span>
                  </div>
                  <p className="text-sm text-slate-600 truncate" data-id="element-15617">
                    Здравствуйте, Анна! Я подготовила вашу карту...
                  </p>
                </div>
                <div className={`w-2.5 h-2.5 rounded-full bg-gradient-to-r ${theme.gradient} mt-1.5 flex-shrink-0`} data-id="element-15618"></div>
              </div>
            </div>
          </div>
        </div>
        <div className="hidden md:flex w-2/3 flex-col bg-slate-50" data-id="element-15619">
          <div className="p-4 border-b border-slate-200 bg-white flex justify-between items-center" data-id="element-15620">
            <div className="flex items-center gap-3" data-id="element-15621">
              <div className="w-10 h-10 rounded-full bg-indigo-100 flex items-center justify-center text-indigo-700 font-bold" data-id="element-15622">
                ЕС
              </div>
              <div data-id="element-15623">
                <h3 className="font-bold text-slate-900" data-id="element-15624">Елена Смирнова</h3>
                <div className="text-xs text-emerald-500 flex items-center" data-id="element-15625">
                  <span className="w-1.5 h-1.5 rounded-full bg-emerald-500 mr-1.5" data-id="element-15626"></span>{' '}
                  В сети
                </div>
              </div>
            </div>
            <Button variant="outline" size="sm" data-id="element-15627">
              Профиль
            </Button>
          </div>
          <div className="flex-grow overflow-y-auto p-6 space-y-6" data-id="element-15628">
            <div className="text-center text-xs text-slate-400 my-4" data-id="element-15629">
              Сегодня
            </div>
            <div className="flex items-start gap-3 max-w-[80%]" data-id="element-15630">
              <div className="w-8 h-8 rounded-full bg-indigo-100 flex items-center justify-center text-indigo-700 font-bold text-xs flex-shrink-0 mt-1" data-id="element-15631">
                ЕС
              </div>
              <div data-id="element-15632">
                <div className="bg-white p-4 rounded-2xl rounded-tl-none shadow-sm border border-slate-100 text-slate-700 text-sm" data-id="element-15633">
                  Здравствуйте, Анна! Я подготовила вашу карту для нашей
                  консультации по синастрии. Подскажите, вам будет удобно
                  созвониться в Zoom завтра в 14:00?
                </div>
                <div className="text-xs text-slate-400 mt-1 ml-1" data-id="element-15634">14:20</div>
              </div>
            </div>
            <div className="flex items-start gap-3 max-w-[80%] ml-auto flex-row-reverse" data-id="element-15635">
              <div className={`w-8 h-8 rounded-full ${theme.bg} ${theme.text} flex items-center justify-center font-bold text-xs flex-shrink-0 mt-1`} data-id="element-15636">
                А
              </div>
              <div data-id="element-15637">
                <div className={`bg-gradient-to-r ${theme.gradient} p-4 rounded-2xl rounded-tr-none shadow-sm text-white text-sm`} data-id="element-15638">
                  Добрый день, Елена! Да, завтра в 14:00 мне отлично подходит.
                  Жду ссылку!
                </div>
                <div className="text-xs text-slate-400 mt-1 mr-1 text-right" data-id="element-15639">
                  14:25
                </div>
              </div>
            </div>
          </div>
          <div className="p-4 bg-white border-t border-slate-200" data-id="element-15640">
            <div className="flex items-center gap-2" data-id="element-15641">
              <input type="text" placeholder="Написать сообщение..." className="flex-grow bg-slate-50 border border-slate-200 rounded-full px-4 py-2.5 text-sm focus:outline-none focus:border-primary focus:ring-1 focus:ring-primary" data-id="element-15642" />
              <button className={`w-10 h-10 rounded-full bg-gradient-to-r ${theme.gradient} text-white flex items-center justify-center transition-opacity hover:opacity-90 flex-shrink-0`} data-id="element-15643">
                <Send className="w-4 h-4 ml-0.5" data-id="element-15644" />
              </button>
            </div>
          </div>
        </div>
      </Card>
    </div>;
}